export enum EnumDateType {
  //Default = 1,
  DateOnly = 2,
  //TimeOnly = 3,
  DateRangePicker = 4,
  DateAndTimeOnly = 5,
}
